import { AMENITIES_ORDER } from './amenities.types';

export const gets = ({ filter, unitGroupId, page, limit }) => ({
  type: AMENITIES_ORDER.GETS.REQUEST,
  payload: {
    filter,
    unitGroupId,
    page,
    limit,
  },
});

export const exportData = ({ filter }) => ({
  type: AMENITIES_ORDER.EXPORT.REQUEST,
  payload: {
    ...filter,
  },
});
